// Configuration file for easy customization
// Replace the image paths with your own logo and banner images

export const siteConfig = {
  // Logo Configuration
  logo: {
    path: "/images/Logo_New.png", // Place your logo in public/images/logo.png
    alt: "Conference Logo"
  },
  
  // Hero Section Configuration
  hero: {
    backgroundImage: "/images/resized_942x751.png", // Place your banner in public/images/banner.jpg
    title: "VASCULAR VOYAGES",
    subtitle: "Fem Pop - Mystery to Mastery",
    date: "13th-14th March 2026",
    workshop: "Workshop on 15th March 2026",
    venue: "Dept. of Vascular & Endovascular Surgery",
    location: "KIMS Hospitals, Hyderabad",
    buttons: [
      {
        text: "DOWNLOAD PROGRAM",
        link: "/downloads/Vascular_Voyages_Schedule_Final_11th March.pdf",
        download: true,
        filename: "Schedule.pdf"
      },
      {
        text: "DOWNLOAD FLYER",
        link: "/downloads/flyer.pdf",
        download: true,
        filename: "Conference-Flyer-2026.pdf"
      }
    ]
  },
  
  // Navigation Menu
  navigation: [
    { name: "HOME", path: "#home" },
    { name: "FACULTY", path: "#faculty" },
    { name: "PROGRAM SCHEDULE", path: "#program-schedule" },
    { name: "WORKSHOP", path: "#workshop" },
    { name: "REGISTRATION", path: "#registration" },
    { name: "ABOUT US", path: "#about" },

  ],
  
  // WhatsApp Contact
  // whatsapp: {
  //   number: "+919876543210", // Replace with your WhatsApp number
  //   text: "Whatsapp Us"
  // }
};